module.exports = __webpack_public_path__ + "img/toolBj.9c71c680.png";